import AddonCheckboxPopup from './AddonCheckboxPopup';

export default AddonCheckboxPopup;
